export default {
  placeholder: 'Merk zoeken...',
};
